module.exports = __webpack_public_path__ + "images/speed-six-active.05a9f99e6f17bf1dfa8b5f4a0be420fb.png";